<template>
  <GridCategoriesBase :id="slug" :hidden="hidden" :title="title">
    <template v-if="isCustom">
      <ButtonCategoryCustomImage
        v-for="(child, index) in categories"
        :key="child.id"
        v-model:available="availables[index]"
        :index="index"
        :category="child"
      />
    </template>
    <template v-else>
      <ButtonCategory
        v-for="(child, index) in categories"
        :key="child.id"
        v-model:available="availables[index]"
        :category="child"
        :parent-display-type="parentDisplayType"
      />
    </template>
  </GridCategoriesBase>
</template>
<script lang="ts" setup>
import type { CategorySchema } from '~/types/schema';
interface Props {
  title?: string | null;
  categories: CategorySchema[];
  slug: string;
  parentDisplayType:
    | 'default'
    | 'center_circle'
    | 'dimensionTest_and_result'
    | 'sponsor'
    | 'shortcuts'
    | 'additional';
}

const props = defineProps({
  title: { default: null },
  categories: null,
  slug: null,
  parentDisplayType: null
});

const availables = ref<boolean[]>(Array(props.categories.length).fill(true));

watch(
  () => props.categories.length,
  (length) => Array(props.categories.length).fill(true)
);

const hidden = computed(() => {
  const hidden = !availables.value.find((b) => b);
  return hidden;
});

const isCustom = computed(() => {
  return !!(
    props.categories.length > 0 &&
    [
      ContentTypes.InterDisciplineActu,
      ContentTypes.InterDisciplineDailyQuiz,
      ContentTypes.InterDisciplineFocusOn,
      ContentTypes.InterDisciplineInfoIntox,
      ContentTypes.InterDisciplineOther,
    ].includes(props.categories[0].contentType)
  );
});
</script>
<style lang="scss" scoped>
article {
  &.hidden {
    display: none;
  }

  display: flex;
  gap: var(--gap_n);
  flex-direction: column;
}
.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(13.2rem, 1fr));
  width: 100%;
  gap: var(--gap_n);
}
.grid-by-2 {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(26.4rem, 1fr));
  width: 100%;
  gap: var(--gap_n);
}
</style>
